import type { HintView } from "../api/types.js";

interface Props {
  hints: HintView[];
  disabled: boolean;
  openingHintId: string | null;
  onRequestOpen: (hint: HintView) => void;
}

/**
 * ヒント一覧。
 * 未開封のヒントは本文を持たない（サーバーが送ってこない）ため、
 * 減点値だけを見せて開封を判断してもらう。
 */
export function HintList({
  hints,
  disabled,
  openingHintId,
  onRequestOpen,
}: Props): React.ReactElement | null {
  if (hints.length === 0) return null;

  return (
    <div className="hints">
      <h4 className="hints__title">ヒント</h4>
      <ul className="hints__list">
        {hints.map((hint) => (
          <li key={hint.id} className="hints__item">
            {hint.opened ? (
              <div className="hint hint--opened">
                <p className="hint__label">
                  ヒント{hint.seq}
                  {hint.penalty > 0 && (
                    <span className="hint__penalty hint__penalty--used">
                      使用済み（-{hint.penalty}点）
                    </span>
                  )}
                </p>
                <p className="hint__body">{hint.body}</p>
              </div>
            ) : (
              <button
                type="button"
                className="btn btn--outline btn--block"
                disabled={disabled || openingHintId !== null}
                onClick={() => onRequestOpen(hint)}
              >
                {openingHintId === hint.id ? (
                  "開いています…"
                ) : (
                  <>
                    ヒント{hint.seq} を見る
                    {hint.penalty > 0 && (
                      <span className="hint__penalty">-{hint.penalty}点</span>
                    )}
                  </>
                )}
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
